import styled from 'styled-components';
import BlackDot from "../../../assests/images/blackdot.svg";
import GreenDot from "../../../assests/images/greendot.svg";
import YellowDot from "../../../assests/images/yellowdot.svg";
import InviteReviewsTop from "../../../assests/images/invite-reviews-top.svg";
import InviteReviewsBottom from "../../../assests/images/invite-reviews-bottom.svg";
import TestimonialsTop from "../../../assests/images/testimonials-top.svg";
import TestimonialsBottom from "../../../assests/images/testimonials-bottom.svg";
import BillQute from "../../../assests/images/message-box-arrow.webp";
export const ClaimNonprofitBanner = styled.section`

    .quote_col{
        img{
            border-radius:0;
        }
    }

    .row{
        align-items: center;
    }
    
    .get-title{
        max-width: inherit;
    }

    position: relative;
    z-index: 11;
   
    .quote_col{
        display: block;

        @media screen and (max-width: 1024px){
            position: relative;
            right: 0;
            top: 0;
            width: 100%;
            max-width: 100%;
        }
    }

    .left_banner{
        padding-left: 68px;

        @media screen and (max-width: 1024px){
            padding-left: 10px;
        }

        @media screen and (max-width: 991px){
            padding: 0px;
        }
        
        @media screen and (max-width: 575px){
            padding: 0 30px;
            margin-top: 20px;
        }

        @media screen and (max-width: 480px){
            padding: 0;
            margin: 30px auto 0px;
        }
    } 

    .left_banner{
        margin-bottom: 0;
    }
`;

export const EasilyShare = styled.div`
    position: relative;
    padding:60px 0;
    z-index: 1;

    @media screen and (max-width: 991px){
        padding: 20px 0 0px;
    }

    &:after {
        background: #F9DC70;
        width: 100%;
        max-width: 950px;
        height: 420px;
        content: "";
        position: absolute;
        top: 0;
        z-index: -1;
        left: 0;
        
        @media screen and (max-width: 1200px){
            max-width: 680px;
            height: 350px;
        }
        
        @media screen and (max-width: 1024px){
            max-width: 600px;
        }

        @media screen and (max-width: 991px){
            max-width: 100%;
        }
    }

    &:before{
        background-image:url(${BlackDot});
        width: 377px;
        height: 400px;
        content: "";
        position: absolute;
        background-repeat: no-repeat;
        top: -165px;
        left: -83px;
        opacity: 0.2;
    }
`;

export const ShareStories = styled.div`
    width: 100%;
    max-width: 445px;
    padding: 55px 0;

    @media screen and (max-width: 991px){
        padding: 20px 0;
        max-width: 100%;
    }

`;

export const TitleEasily = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){
        font-size:26px;
        line-height: 34px;
        margin-bottom: 15px;
    }
`;

export const EasilyShareMain = styled.section`
    background: #F1FEFF;
    padding-bottom: 70px;
    overflow: hidden;

    @media screen and (max-width: 991px){
        padding-bottom: 70px;
    }

    @media screen and (max-width: 575px){
        padding-bottom: 20px;
    }
`;
export const ContentText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 0px;

    @media screen and (max-width: 575px){
        font-size: 16px;
        line-height: 24px;
    }
`;

export const ShareStoriesImage = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding: 10px;
    flex: 1;
    position: relative;
    img{
        width: 100%;
        max-width: 780px;
    }
    &:before{
        background-image:url(${GreenDot});
        width: 377px;
        height: 100%;
        content: "";
        position: absolute;
        background-repeat: no-repeat;
        top: -78px;
        left: 62px;
        opacity: 1;
        z-index: -1;
    }
    &:after{
        background-image:url(${YellowDot});
        width: 377px;
        height: 495px;
        content: "";
        position: absolute;
        background-repeat: no-repeat;
        bottom: -68px;
        right: 86%;
        opacity: 1;
        z-index: -1;
    }
`;

export const EasilyShareSupporters = styled.div`
    display: flex;
    gap: 42px;

    @media screen and (max-width: 991px){
        flex-direction: column;
        gap: 30px;
    }
`;

export const EasilyShareVideo = styled.div`
    display: flex;
    gap: 42px;
    position: relative;
    z-index: 1;
    padding-bottom:60px;

    @media screen and (max-width: 1024px){
        padding-top:50px;
    }

    @media screen and (max-width: 991px){
        padding-bottom: 0px;
        margin-top: 100px;
        background: #FFD495;
        border-radius: 0 0 0 30px;
    }

    &:after {
        background: #FFD495;
        width: 100%;
        max-width:1081px;
        height: 88%;
        content: "";
        position: absolute;
        top: 57px;
        z-index: -1;
        right: 0;
        border-radius: 0px 0px 0px 30px;

        @media screen and (max-width: 1440px){
            max-width:839px;
        }
        @media screen and (max-width: 1024px){
            max-width: 100%;
        }

        @media screen and (max-width: 991px){
            background: none;
        }

        @media screen and (max-width: 575px){
            border-radius: 0px 0px 0px 20px;
        }
    }
`;
export const VideoSection = styled.div`
    width:100%;
    max-width: 588px;
    position: relative;

    @media screen and (max-width: 1024px){
        margin: 0 auto;
    }

    .video{
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 15px;
        padding: 10px;
        width:100%;
        max-width: 588px;
        
        @media screen and (max-width: 1024px){
            margin: -100px auto 0px;
        }
    
    }
    &:before{
        background-image:url(${GreenDot});
        width: 377px;
        height: 100%;
        content: "";
        position: absolute;
        background-repeat: no-repeat;
        bottom: -100px;
        left: 38%;
        opacity: 1;
        z-index: -1;
    }
`;

export const VideoWrapper = styled.div`
    display: flex;

    @media screen and (max-width: 1024px){
        flex-direction: column;
    }
`;

export const GnpStatistics = styled.div`
    flex:1;
    padding: 96px 20px 0px 20px;

    @media screen and (max-width: 1024px){
        padding-top: 30px;
    }

    @media screen and (max-width: 991px){
        padding-bottom: 50px;
    }

    @media screen and (max-width: 575px){
        padding: 20px 10px 40px 10px;
    }
`;

export const GnpTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom:15px;
    margin-top: 27px;
    @media screen and (max-width: 575px){
        margin-top: 15px;
    }
`;

export const GnpStatisticsList = styled.ul`
   padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

export const GnpStatisticsItem = styled.li`
    background: #333333 0% 0% no-repeat padding-box;
    border-radius: 10px;
    padding:12px 20px;

    strong{
        color: #F9DC70;
        font-family: "Jost", sans-serif;
        font-size:16px;
        font-weight: 600;
        line-height: 21px;
        margin-bottom: 0px;
    }
    span{
        color: #fff;
        font-family: "Jost", sans-serif;
        font-size:16px;
        font-weight: 400;
        line-height: 21px;
        margin-bottom: 0px;
    }
`;
  
export const MoreDonors = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 15px;
    width:100%;
    max-width:996px;
    padding:20px;
    display: flex;
    margin:60px auto;
    gap:24px;
    align-items: center;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 1024px){
        margin: 30px auto 50px;
    }
    
    @media screen and (max-width: 991px){
        flex-direction: column;
        padding-top: 50px;
        margin-top: 0px;
    }

    @media screen and (max-width: 575px){
        padding-top: 40px;
    }
`;

export const MoreDonorsLeft = styled.div`
    width: 100%;
    max-width: 483px;
    @media screen and (max-width: 991px){
        max-width: 100%;
    }
`;

export const MoreDonorsRight = styled.div`
 flex:1;
    img{
        width:100%;
    }
`;

export const TextCol = styled.span`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 700;
    line-height: 27px;
    margin-bottom: 12px;
    display:block;
`;
export const InviteReviews = styled.div`
    background: #33A7AE;
    padding: 0px 0px 50px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    
    @media screen and (max-width: 575px){
        padding: 30px 0px 38px;
    }

    &::before{
        content: '';
        position: absolute;
        background-image:url(${InviteReviewsTop});
        background-repeat: no-repeat;
        background-size: cover;
        background-color: #F1FEFF;
        width: 100%;
        height: 77px;
        margin: auto;
        top: -77px;
        left: 0;
        right: 0;
        
        @media screen and (max-width: 575px){
            height: 17px;
            top: -17px;
        }
    }

    &::after{
        content: '';
        position: absolute;
        background-image:url(${InviteReviewsBottom});
        background-repeat: no-repeat;
        background-size: cover;
        background-color: #F1FEFF;
        width: 100%;
        height: 56px;
        margin: auto;
        bottom: -56px;
        left: 0;
        right: 0;
        background-position: bottom;

        @media screen and (max-width: 575px){
            height: 17px;
            bottom: -17px;
        }
    }
`;

export const SocialMedia = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 20px;
    padding:20px 20px 1px 20px;

    .social-media-requests-box-title{
        max-width: inherit;
    }

    .ideas-collecting-reviews{
        display:none;
    }

    .social-media-requests-box{
        margin-bottom:30px;
    }

    .social-media-req-li{
        align-items: center;
        @media screen and (max-width: 767px){
            align-items: flex-start;
        }
        @media screen and (max-width: 575px){
            flex-direction: column;
            row-gap: 10px;
        }
    }
`;


export const InviteTitle = styled.h3`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 42px;
    margin-bottom: 15px;

    @media screen and (max-width: 991px){
        font-size:26px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size:24px;
        line-height: 36px;
    }

    @media screen and (max-width: 575px){
        font-size:22px;
        line-height: 34px;
    }
`;

export const InviteText = styled.p`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 21px;
    margin-bottom: 20px;
`;

export const EasilyReachSection = styled.div`
    background: #F1FEFF 0% 0% no-repeat padding-box;
    padding: 100px 0 157px;

    @media screen and (max-width: 1024px){
        padding: 100px 0 130px;
    }

    @media screen and (max-width: 575px){
        padding: 50px 0 50px;
    }

    .search-header{
        max-width: inherit;
        .seach-box{
            width:100%;
            gap: 360px;
            @media screen and (max-width: 991px){
                gap: 30px;
            }
            @media screen and (max-width: 480px){
                justify-content: flex-start;
                align-items: flex-start;
            }
        }
        .btn-outline-success{
            width:100%;
            max-width: 194px;
              @media screen and (max-width: 480px){
                  max-width: 110px;
                  padding: 8px 0;
              }
        }
    }

    
`;

export const AudienceToday = styled.div`
    background: #333333 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 30px #00000014;
    border-radius: 20px;
    padding:30px;

    @media screen and (max-width: 575px){
        padding:15px;
        border-radius: 15px;
    }

    .search-header .input-group {
        width: 75%;
        @media screen and (max-width: 575px){
            width: 50%;
        }
    }

    .seach-box{}
`;

export const AudienceTitle = styled.h3`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 500;
    line-height: 43px;
    margin-bottom: 30px;

    @media screen and (max-width: 991px){
        font-size:28px;
        line-height: 40px;
    }

    @media screen and (max-width: 767px){
        font-size:26px;
        line-height: 38px;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 575px){
        font-size:24px;
        line-height: 36px;
    }
`;

export const ReviewSerchBox = styled.div`
    .search-header{
        display: flex;
        align-items: center;
        background: #fff;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 10px;
        padding:6px;
        width: 100%;
        justify-content: space-between;

        @media screen and (max-width: 767px){
            margin-bottom: 0px;
        }
        @media screen and (max-width: 480px){
            justify-content: flex-start;
        }

        .zipcode{
            max-width: 150px;

            @media screen and (max-width: 480px){
                max-width: 100%;
                width: 100%;
            }

            .form-control{
                padding-left: 20px !important;
            }
            &:after {
                background: #333333;
                position: absolute;
                width: 1px;
                height: 40px;
                content: "";
                top: -5px;
            }
        }
    
        .input-group{
            width: auto;
        
            .form-control{
                border: none;
                padding-top: 2px;
                padding-bottom: 2px;
                font-family: "Jost", sans-serif;
                font-size: 18px;
                font-weight: 500;
                line-height: 26px;
                padding-left: 0px;
                &:focus{
                    background: transparent !important;
                }
                &::-webkit-input-placeholder { 
                    color: #333333;
                    }
                &::-moz-placeholder { 
                    color: #333333;
                    }
                &:-ms-input-placeholder { 
                    color: #333333;
                    }
                &:-moz-placeholder { 
                    color: #333333;
                }
            }
        }
        .btn-outline-success{
            background: #01606F;
            border: none;
            color: #fff;
            font-family: "Jost", sans-serif;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            padding: 12px 40px;
            transition: all 0.5s;

            @media screen and (max-width: 575px){
                max-width: 100%;
            }

            &:hover{
                background: #FFD495;
                color: #333333;
                transition: all 0.5s;
            }
        }
    }
`;

export const InputGroupIcon = styled.div`
    padding-right: 10px;
     .search-group-icon{
        width: 48px;
        min-width:48px;
        height: 48px;
        background: #F9DC70;
        border-radius: 10px;
        padding: 10px;
    }
`;

export const BoostDonor = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding: 30px;
    display: flex;
    gap: 24px;
    align-items: center;
    margin-top:60px;
    position: relative;

    @media screen and (max-width: 1024px){
        margin-top: 190px;
    }

    @media screen and (max-width: 991px){
        flex-direction: column-reverse;
        margin-top: 202px;
    }
    
    @media screen and (max-width: 767px){
        margin-top: 220px;
    }
    
    @media screen and (max-width: 480px){
        padding: 20px;
    }
`;

export const ClientContent = styled.div`
    width: 100%;
    max-width: 354px;
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 500;
    line-height:24px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }
`;

export const DonarTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 40px;
    margin-bottom: 15px;

    @media screen and (max-width: 991px){
        font-size:26px;
        line-height: 34px;
    }

    @media screen and (max-width: 767px){
        font-size:24px;
        line-height: 30px;
    }
`;
export const DonarText = styled.p`
    margin-bottom: 30px;

    @media screen and (max-width: 991px){
        margin-bottom: 15px;
    }

    a{
        color: #01606F;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        font-weight: 700;

        img{
            transform: rotate(272deg);
            width: 16px;
            margin-top: 3px;
        }
    }
`;

export const ClientImageCol = styled.div`
    position: relative;
    @media screen and (max-width: 480px){
        max-width: 350px;
        margin: 0 auto;   
    }

    @media screen and (max-width: 360px){
        max-width: 250px;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const BillQut = styled.div`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 20px;
    padding: 20px;
    position: absolute;
    background-size: cover;
    width: 383px;
    right: 30px;
    bottom: 93px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width: 1280px){
        width: 330px;
    }
    @media screen and (max-width: 1200px){
        width: 270px;
    }
    @media screen and (max-width: 1024px){
        width: 450px;
        right: 45px;
        bottom: auto;
        top: -140px;
    }

    @media screen and (max-width: 991px){
        width: 500px;
        margin: auto;
        right: 0;
        left: 0;
        top: -150px;
    }
    @media screen and (max-width: 767px){
        max-width: 250px;
        border-radius: 15px;
        top: -200px;
    }

    &:after{
        background:url(${BillQute});
        position: absolute;
        content: "";
        width: 74px;
        background-repeat: no-repeat;
        height: 52px;
        bottom: -52px;
        left: 105px;
        @media screen and (max-width: 1280px){
            left: 69px;
        }
        @media screen and (max-width: 1200px){
            left: 55px;
        }

        @media screen and (max-width: 1142px){
            left: 113px;
        }
        @media screen and (max-width: 1100px){
            left: 155px;
        }
        @media screen and (max-width: 991px){
            left: auto;
            right: 70px;
        }
    }
    
    strong{
        color: #fff;
        font-family: "Jost", sans-serif;
        font-size:18px;
        font-weight: 700;
        line-height: 27px;
        margin-bottom: 0px;
        display: block;
    }

    span{
        color: #333333;
        font-family: "Jost", sans-serif;
        font-size:18px;
        font-weight: 700;
        line-height: 27px;
        margin-bottom: 0px;
        display: block;
    }
`;
export const BillText = styled.p`
    color: #FFFFFF;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom:15px;

    @media screen and (max-width: 1024px){
        font-size: 14px;
        line-height: 20px;
    }
`;

export const BottomTitle = styled.div`
    display: flex;
    justify-content: space-between;

    img{
        transform: rotate(180deg);
        width: 60px;

        @media screen and (max-width: 1024px){
            width: 40px;
        }
    }
`;

export const Volunteers = styled.div`
    display: flex;
    gap: 59px;

    @media screen and (max-width: 1200px){
        gap: 40px;
    }

    @media screen and (max-width: 991px){
        flex-direction: column;
    }
`;

export const VolunteersImage = styled.div`
    width:100%;
    max-width:588px;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 10px;
    overflow: hidden;

    @media screen and (max-width: 991px){
        margin: 0 auto;
    }
    @media screen and (max-width: 575px){
        max-width:400px;
    }
    @media screen and (max-width: 480px){
        max-width:300px;
    }

    img{
        width: 100%;
        display: block;
        object-fit: cover;
        height: 100%;
    }
`;
export const VolTitle = styled.div`
    color: #000;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 40px;
    padding:30px 18px;
    background: #F9DC70 0% 0% no-repeat padding-box;
    border-radius: 20px;
    position: absolute;
    top: 90px;
    right: auto;
    left: 75px;

    @media screen and (max-width: 1200px){
        font-size: 26px;
        line-height: 34px;
        max-width: max-content;
        padding: 20px;
    }

    @media screen and (max-width: 1024px){
        font-size: 24px;
        line-height: 32px;
        padding: 15px;
        left: 50px;
        border-radius: 15px;
    }

    @media screen and (max-width: 991px){
        left: 0px;
    }
    
    @media screen and (max-width: 767px){
        font-size: 22px;
        line-height: 30px;
    }

    @media screen and (max-width: 575px){
        font-size: 20px;
        line-height: 26px;
    }

    @media screen and (max-width: 480px){
        padding: 10px;
        font-size: 18px;
        line-height: 24px;
        top: 40px;
    }
`;

export const VolunteersNumber = styled.div`
    flex: 1;
`;

export const NonprofitsList = styled.ul`
    padding: 160px 0 0 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    @media screen and (max-width: 1200px){
        padding: 134px 0 0 0;
    }
    @media screen and (max-width: 991px){
        padding: 0px 0 0 0;
        justify-content: center;
    }
`;

export const NonprofitsItem = styled.li`
    background: #33A7AE 0% 0% no-repeat padding-box;
    border-radius: 20px;
    padding:20px;
    width: 100%;
    max-width: 493px;

    @media screen and (max-width: 991px){
        max-width: 100%;
    }

    @media screen and (max-width: 575px){
        border-radius: 15px;
    }

    &:nth-child(2){
        margin-left:70px;
        @media screen and (max-width: 575px){
            margin-left:0px;
        }
    }
`;

export const NonprofitsStrong = styled.div`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size: 50px;
    font-weight: 600;
    line-height: 33px;
    margin-bottom: 15px;
    display: block;

    @media screen and (max-width: 1200px){
        font-size: 40px;
    }
    
    @media screen and (max-width: 575px){
        font-size: 30px;
        margin-bottom: 10px;
    }
`;

export const NonprofitsSpan = styled.div`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 0px;

    @media screen and (max-width: 1200px){
        font-size: 18px;
        line-height: 26px;
    }

    @media screen and (max-width: 575px){
        font-size: 16px;
        line-height: 24px;
    }
`;

export const GreatNonprofits = styled.div`
    position: relative;
    padding-top:60px;
`;

export const TestimonialsSection = styled.div`
    background: #01606F;
    padding: 10px 0px 20px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;

    @media screen and (max-width: 767px){
        padding: 30px 0px 10px;
    }

    &::before{
        content: '';
        position: absolute;
        background-image:url(${TestimonialsTop});
        background-repeat: no-repeat;
        background-size: cover;
        background-color: #F1FEFF;
        width: 100%;
        height: 77px;
        margin: auto;
        top: -76px;
        left: 0;
        right: 0;

        @media screen and (max-width: 575px){
            height: 17px;
            top: -17px;
        }
    }

    &::after{
        content: '';
        position: absolute;
        background-image:url(${TestimonialsBottom});
        background-repeat: no-repeat;
        background-size: cover;
        background-color: #F1FEFF;
        width: 100%;
        height: 56px;
        margin: auto;
        bottom: -54px;
        left: 0;
        right: 0;
        background-position: bottom;

        @media screen and (max-width: 575px){
            height: 17px;
             bottom: -17px;
        }
    }  
`;

export const  TestimonialBoxGroup = styled.div`
    column-count: 2;
    counter-reset: item-counter;

    @media screen and (max-width: 767px){
        column-count: 1;
    }
`;

export const ClientMainBox = styled.div`
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    align-items: baseline;
    position: relative;
    z-index: 9;
`;

export const ClientBox = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 30px #0000001A;
    border-radius: 20px;
    padding: 21px 20px;
    margin-bottom: 24px;
    break-inside: avoid;

    @media screen and (max-width: 767px){
        margin-bottom: 20px;
    }
    @media screen and (max-width: 575px){
        border-radius: 15px;
        padding: 15px;
    }

    &:last-child{
        margin-bottom: 0px;
        
        @media screen and (max-width: 767px){
            margin-bottom: 20px;
        }
    }
`;

export const ClientReview = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 20px;
`;

export const ClientDesignation = styled.div` 
    display: flex;
    align-items: center;
    gap: 10px;
    img{
        width: 73px;
        height: 73px;
        min-width: 73px;
    }
`;

export const Designation = styled.div` 
    strong{
        color: #000;
        font-family: "Jost", sans-serif;
        font-size:18px;
        font-weight: 600;
        line-height:21px;
        margin-bottom: 8px;
        display: block;
    }
    a{
    text-decoration:none;
    }
    span{
        color: #33A7AE;
        font-family: "Jost", sans-serif;
        font-size:16px;
        font-weight: 500;
        line-height:21px;
        margin-bottom: 0px;
    }
`;

export const TestimonialTitle = styled.h2` 
    color:#fff;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 33px;
    position: relative;
    z-index: 9;
    @media screen and (max-width: 575px){
        margin-bottom: 20px;
    }
`;
export const FreeProfile = styled.div` 
    padding: 106px 0 60px 0;
    background-color: #fff;

    @media screen and (max-width: 767px){
        padding: 86px  0 50px 0
    }
    @media screen and (max-width: 575px){
        padding: 40px  0 40px 0
    }
`;
export const FreeProfileText = styled.div` 
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 20px;

    @media screen and (max-width: 767px){
        font-size:16px;
        line-height: 24px;
    }
    
    &:last-child{
        margin-bottom: 0px;
    }
`;
export const CollectDonations = styled.div`
    background: #F1FEFF 0% 0% no-repeat padding-box;
    padding:60px 0 60px 0;

    @media screen and (max-width: 1200px){
        padding: 106px 0 20px 0;
    }

    @media screen and (max-width: 1024px){
        padding: 30px 0 20px 0;
    }

    @media screen and (max-width: 991px){
        padding: 50px 0 50px 0;
    }
    @media screen and (max-width: 575px){
        padding: 50px 0 40px 0;
    }
`;

export const GreatNonprofitWrapper = styled.div` 
    display: flex;
    gap: 30px;
    position: relative;
    align-items: center;

    @media screen and (max-width: 991px){
        padding-right: 15px;
        gap: 20px;
        flex-wrap: wrap;
    }

    @media screen and (max-width: 767px){
        flex-direction: column;
    }

    &:after{
        background: #fff;
        position: absolute;
        content: "";
        width: 100%;
        height: 75%;
        bottom: 0;
        z-index: 1;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 15px;
            @media screen and (max-width: 991px){
              height: 100%;
              position: static;
             }
    }
`;

export const GreatNonprofitsLeft = styled.div` 
    width: 100%;
    max-width: 588px;

    @media screen and (max-width: 991px){
        max-width:100%;
    }
    @media screen and (max-width: 767px){
        max-width: 100%;
    }

    img{
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const GreatNonprofitsRight = styled.div` 
    flex:1;
    position: relative;
    z-index: 11;
    padding: 30px 30px 30px 0px;

    @media screen and (max-width: 767px){
        padding: 0px;
    }

    img{
        width:100%;
        max-width: 558px;
   @media screen and (max-width:991px){
       max-width: 100%;
   }
        @media screen and (max-width: 767px){
            max-width: 100%;
            padding: 0 20px 30px 20px;
        }
    }
`;

export const GreatTitle = styled.h2` 
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 45px;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){
        font-size: 26px;
        line-height: 34px;
    }
    
    @media screen and (max-width: 991px){
        font-size: 22px;
        line-height: 32px;
    }
`;

export const GreatText = styled.p` 
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 0px;
    padding: 30px 0px 30px 30px;
    position: relative;
    z-index: 11;
    
    @media screen and (max-width: 991px){
        font-size: 16px;
        line-height: 24px;
        padding:0px;
    }

    @media screen and (max-width: 575px){
        padding: 0px;
    }
`;

export const GreatNonprofitsBadge = styled.div` 
    padding-bottom: 60px;
    background: #F1FEFF;
    @media screen and (max-width: 991px){
        padding-bottom: 50px;
    }
`;

export const BadgeWrapper = styled.div` 
    display:flex;
    gap:22px;

    @media screen and (max-width: 991px){
        flex-direction: column;
    }
`;

export const BadgeTitle = styled.h2` 
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: 700;
    line-height: 60px;
    margin-bottom: 20px;

    @media screen and (max-width: 1024px){
        font-size:30px;
        line-height: 50px;
        margin-bottom: 15px;
    }

    @media screen and (max-width: 1024px){
        font-size:24px;
        line-height: 40px;
     }
`;

export const BadgeLeft = styled.div` 
    width:100%;
    max-width:705px;

    @media screen and (max-width: 1024px){
        max-width: 50%;
    }

    @media screen and (max-width: 991px){
        max-width: 100%;
    }
`;

export const BadgeRight = styled.div` 
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:16px;
    flex:1;
    img{
        width:100%;
    }
`;

export const BadgeSmall = styled.span` 
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 700;
    line-height: 27px;
    margin-bottom: 20px;
    display:block;

    @media screen and (max-width: 991px){
        margin-bottom: 15px;
    }
`;

export const BadgeText = styled.p` 
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 400;
    line-height: 27px;
    margin-bottom: 20px;

    @media screen and (max-width: 991px){
        font-size:16px;
        line-height: 24px;
        margin-bottom: 15px;
    }
    @media screen and (max-width: 767px){
        margin-bottom: 10px;
    }

    strong{
        color: #01606F;
        font-weight: 700;
    }
`;

export const RecognitionToday = styled.div` 
    background: #333333;
    box-shadow: 0px 10px 30px #00000014;
    padding:50px 0;

    @media screen and (max-width: 575px){
        padding: 40px 0 30px;
    }

    .btn-outline-success {
        padding: 12px 73px !important;
    }
    .search-header{
        .seach-box{
            width:100%;
            gap: 360px;
            
            @media screen and (max-width: 991px){
                gap: 30px;
            }
            @media screen and (max-width: 575px){
                gap: 10px;
            }
            @media screen and (max-width: 480px){
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
            }
        }

        .zipcode:after{
            @media screen and (max-width: 480px){
                    width: 0 !important;
            }
        }
    }
`;

export const RecognitionTitle = styled.h2` 
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 700;
    line-height: 45px;
    margin-bottom: 20px;
    display: flex;
    gap: 10px;

    @media screen and (max-width: 991px){
        font-size:28px;
        line-height: 40px;
    }
    
    @media screen and (max-width: 575px){
        font-size:26px;
        line-height: 38px;
    }
`;